<template>
  <v-sheet class="pb-4">
    <div class="accent-block mt-4 mb-4" v-if="afficheAideCreation">
      <template v-if="modification">
        <p>
          Veuillez effectuer les modifications relatives aux membres de votre association
          : Ajout, modification et suppression de membre.
        </p>
      </template>
      <template v-else>
        <p>
          Nous vous rappelons qu'afin que votre demande soit complète il convient d'avoir
          :
        </p>
        <ul style="list-style: none">
          <li>
            <a-plain-check :value="auMoins1Comite" /> au moins un membre de la direction
          </li>
          <li>
            <a-plain-check :value="auMoins7Fondateurs" /> au moins 7 membres fondateurs
          </li>
        </ul>
        <p>
          Les membres de la direction saisis seront automatiquement repris dans les
          membres fondateurs, il est inutile de ressaisir ces derniers.
        </p>
      </template>
    </div>
    <v-row dense>
      <v-col cols="12">
        <a-plain-text-component :rules="[serverRule('membres.nombreDirection')]">
          <span class="am-t2 bold"> Membres de la direction </span>
        </a-plain-text-component>
      </v-col>

      <v-col cols="12" v-if="afficheAideCreation">
        <div class="d-flex justify-center">
          <v-btn data-testid="ajouter-membre-direction" @click="ajouterComite"> Ajouter un membre de la direction </v-btn>
        </div>
      </v-col>
    </v-row>
    <transition-group tag="div" name="comite" class="row row--dense">
      <v-col
        cols="12"
        md="4"
        v-for="(a, i) in tousComite"
        :key="a.key"
        @drop="onDropMembre($event, i)"
        @dragover.prevent
      >
        <a-personne-card
          :draggable="afficheAideCreation"
          @dragstart="startDragMembre($event, a)"
          :value="a"
          :editable="afficheAideCreation"
          @supprime="supprimeComite(a)"
          @modifie="editeComite(a)"
          @undo="undoSupprime(a)"
        />
      </v-col>
    </transition-group>
    <v-row v-if="!modification" dense>
      <v-col cols="12">
        <a-plain-text-component :rules="[serverRule('membres.nombre')]">
          <span class="am-t2 bold"> Membres fondateurs </span>
        </a-plain-text-component>
      </v-col>

      <v-col cols="12" v-if="afficheAideCreation">
        <div class="d-flex justify-center">
          <v-btn data-testid="ajouter-membre-fondateur" @click="ajouterFondateur"> Ajouter un membre fondateur</v-btn>
        </div>
      </v-col>

      <v-col cols="12" md="4" v-for="(a, i) in tousFondateurs" :key="`f${i}`">
        <a-fondateur-card
          :value="a"
          :editable="afficheAideCreation"
          @supprime="supprimeFondateur(a)"
          @modifie="editeFondateur(a)"
        />
      </v-col>
    </v-row>
    <a-edition-fondateur-dialog ref="fondateur" />
    <a-edition-personne-dialog ref="comite" />
  </v-sheet>
</template>

<script>
import makeValueData from "@/mixins/makeValueData";
import makeRules from "@/mixins/makeRules";
import ValueDataRules from "@/mixins/ValueDataRules";
import DepotMixin from "./DepotMixin";
import _ from "lodash";

import { mapPhysique, mapMorale } from "@/components/membre/EditionPersonneDialog";

import { findIndexMembres, cleIndexageMembre } from "@/mixins/forms/makeSaisieComponent";
import copy from "@/services/copy";

function wrap(collection) {
  return collection || [];
}

function copyPersonneValue(src) {
  var dest = {};
  mapPhysique(src, dest);
  mapMorale(src, dest);
  delete dest.estFondateur;
  delete dest.action;
  return dest;
}

function mapTo(src, dest, me, input) {
  src = src || {};
  const comite = src.comite || {};
  const fondateurs = src.fondateurs || {};
  dest.indexMembres = src.indexMembres || [];
  dest.comite = {
    morales: wrap(comite.morales),
    physiques: wrap(comite.physiques),
    reprises: wrap(comite.reprises),
  };
  dest.fondateurs = {
    morales: wrap(fondateurs.morales),
    physiques: wrap(fondateurs.physiques),
  };

  if (input) {
    dest.comite.morales = dest.comite.morales.map(m => ({ ...m, key: `${m.uuid || m.localUuid}` }));
    dest.comite.physiques = dest.comite.physiques.map(m => ({ ...m, key: `${m.uuid || m.localUuid}` }));
    dest.comite.reprises = dest.comite.reprises.map(m => ({ ...m, key: `${m.uuid || m.localUuid}` }));
  }
}

function ajouteCollection(collection, type) {
  return (d, index) => ({
    type,
    ...d,
    collection,
    prefix: `${collection[0]}.${collection[1]}[${index}]`,
    index,
  });
}

function toFondateur(valeur) {
  return {
    issueComite: true,
    civilite: valeur.civilite,
    nom: valeur.nom,
    prenom: valeur.prenom,
    formeJuridique: valeur.formeJuridique,
    denomination: valeur.denomination,
    type: valeur.type,
    index: valeur.index,
  };
}

export default {
  mixins: [DepotMixin, makeValueData(mapTo), makeRules(), ValueDataRules],
  props: {
    modification: {
      type: Boolean,
      default: false,
    },
    membresOrigine: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.$nextTick(() => this.emitDisabled());
  },
  data() {
    return {
      draggedMembre: null,
    };
  },
  computed: {
    tousComite() {
      const membres = [
        ...this.comite.physiques.map(
          ajouteCollection(["comite", "physiques"], "physique")
        ),
        ...this.comite.morales.map(ajouteCollection(["comite", "morales"], "morale")),
        ...this.comite.reprises.map(ajouteCollection(["comite", "reprises"], "reprise")),
      ];
      const indexMembres = this.indexMembres;
      return membres
        .map(m => ({ ...m, statut: this.calculeStatut(m) }))
        .sort(
          (l, r) =>
            findIndexMembres(l, indexMembres, 10000) -
            findIndexMembres(r, indexMembres, 10000)
        );
    },
    tousFondateurs() {
      return [
        ...this.tousComite.filter(c => c.estFondateur).map(c => toFondateur(c)),
        ...this.fondateurs.physiques.map(
          ajouteCollection(["fondateurs", "physiques"], "physique")
        ),
        ...this.fondateurs.morales.map(
          ajouteCollection(["fondateurs", "morales"], "morale")
        ),
      ];
    },
    auMoins1Comite() {
      return this.tousComite.filter(c => c.action !== "supprime").length >= 1;
    },
    auMoins7Fondateurs() {
      return this.tousFondateurs.length >= 7;
    },
    suiteDisabled() {
      if (this.modification) {
        return !this.auMoins1Comite;
      }

      return !this.auMoins1Comite || !this.auMoins7Fondateurs;
    },
  },
  watch: {
    suiteDisabled() {
      this.emitDisabled();
    },
  },
  methods: {
    calculeStatut(m) {
      const { uuid } = m;
      const found = this.membresOrigine.find(i => i.uuid === uuid);
      if (!found) {
        return "ajout";
      }

      var cm = copyPersonneValue(m);
      var cf = copyPersonneValue(found);
      if (!_.isEqual(cm, cf)) {
        return "modifie";
      }

      return null;
    },
    emitDisabled() {
      this.$emit("disabled", this.suiteDisabled);
    },
    resoudCollection(collection) {
      return this[collection[0]][collection[1]];
    },
    ajouterComite() {
      this.$refs.comite.nouveau(valeur => {
        const maxKey = this.clefsMax(this.tousComite);
        const collection = this.resoudCollection(["comite", valeur.type + "s"]);

        const localUuid = crypto.randomUUID();
        //ajout dans l'index
        const membre = { ...valeur, key: maxKey + 1, localUuid };
        this.indexMembres.push(cleIndexageMembre(membre));
        collection.push(membre);
        this.normaliseIndex();
        this.changed();
      });
    },
    ajouterFondateur() {
      this.$refs.fondateur.nouveau(valeur => {
        this.resoudCollection(["fondateurs", valeur.type + "s"]).push(valeur);
        this.changed();
      });
    },
    undoSupprime(a) {
      a.action = null;
      this.resoudCollection(a.collection).splice(a.index, 1, a);
      this.changed();
    },
    normaliseIndex() {
      //rajout les index des membres rajoutés
      this.indexMembres = this.indexMembres.map(im => {
        const { localUuid } = im;
        if (localUuid) {
          const index = this.resoudCollection(["comite",im.collection]).findIndex(
            m => m.localUuid === localUuid
          );
          return { ...im, index };
        }
        return im;
      });
    },
    supprimeComite(a) {
      if (this.modification) {
        a.action = "supprime";
        const collection = this.resoudCollection(a.collection);
        collection.splice(a.index, 1, a);
        this.changed();
        return;
      }

      const collection = this.resoudCollection(a.collection);
      const membre = collection[a.index];
      collection.splice(a.index, 1);

      //suppression dans l'index
      const i = findIndexMembres(membre, this.indexMembres);
      this.indexMembres.splice(i, 1);
      this.normaliseIndex();

      this.changed();
    },
    supprimeFondateur(a) {
      if (a.issueComite) {
        const collection = this.resoudCollection(["comite", a.type + "s"]);
        const membre = collection[a.index];
        collection.splice(a.index, 1, { ...membre, estFondateur: false });
      } else {
        const collection = this.resoudCollection(a.collection);
        collection.splice(a.index, 1);
      }
      this.changed();
    },
    editeFondateur(a) {
      const index = a.index;
      const collection = this.resoudCollection(a.collection);
      var val = collection[index];
      this.$refs.fondateur.edite(val, valeur => {
        collection.splice(index, 1, valeur);
        this.changed();
      });
    },
    editeComite(a) {
      const index = a.index;
      const collection = this.resoudCollection(a.collection);
      this.$refs.comite.edite(a, valeur => {
        collection.splice(index, 1, valeur);
        this.changed();
      });
    },
    clefsMax(collection) {
      //trouve la valeur maximam de key dans la collection
      const keys = collection.map(m => m.key);
      if (!keys.length) {
        //pas d'entrée, donc et bien c'est 0, sinon Math.max renvoi -Infinity et c'est pas ouf
        return 0;
      }
      return Math.max(...keys);
    },
    startDragMembre(evt, membre) {
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      this.draggedMembre = copy(membre);
    },
    onDropMembre(evt, index) {
      if (this.draggedMembre) {
        const cle = copy(this.draggedMembre);
        const i = findIndexMembres(cle, this.indexMembres);
        if (i === index) {
          return;
        }
        const old = this.indexMembres[i];
        //supprime en position de départ
        this.indexMembres.splice(i, 1);
        // insert en position d'arrivé
        this.indexMembres.splice(index, 0, old);
        this.draggedMembre = null;
        this.changed();
      }
    },
  },
};
</script>

<style>
.comite-move {
  transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
}
</style>
